import * as tenantStackActions from '@Actions/tenantStack';
import { error as snackbarError } from '@innovyze/stylovyze';
import { PayloadAction } from '@reduxjs/toolkit';
import { stackCreateGreengrass } from '@Services/tenantStack';
import { TenantStackCreateRequest } from '@Types/tenatStack';
import { AxiosResponse } from 'axios';
import { put, retry, takeLatest } from 'redux-saga/effects';

function* tenantStackCreateSaga(
	action: PayloadAction<TenantStackCreateRequest>,
) {
	const { tenantStackCreateResolved, tenantStackCreateRejected } =
		tenantStackActions;

	try {
		console.log(action.payload);
		const response: AxiosResponse<unknown> = yield retry(
			5,
			1500,
			stackCreateGreengrass,
		);

		if (response.data) {
			yield put(tenantStackCreateResolved());
		} else {
			yield put(tenantStackCreateRejected());
			throw new Error('OperationStatus != SUCCESS');
		}
	} catch (e) {
		yield put(snackbarError('Error creating greengrass core'));
		yield put(tenantStackCreateRejected());
	}
}

function* watchtenantStackCreateSaga() {
	yield takeLatest(
		tenantStackActions.tenantStackCreate,
		tenantStackCreateSaga,
	);
}

export default [
	watchtenantStackCreateSaga(), //
];
